module.exports = __webpack_public_path__ + "img/014.6dc29950.jpg";